export default __webpack_public_path__ + "static/media/login-background-item.be0e1d4a.svg";